<template>
    <div class="legend-container flex flex-wrap gap-3 justify-content-center mt-3">
        <div 
            v-for="(color, label) in colorMap" 
            :key="label" 
            class="legend-item flex align-items-center gap-2"
        >
            <span class="legend-color" :style="{ backgroundColor: color }"></span>
            <span class="legend-label text-xs font-semibold">{{ label }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorLegendCompact',
    props: {
        colorMap: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.legend-container {
    width: 100%;
}

.legend-color {
    width: 24px;
    height: 8px;
    border-radius: 4px;
    display: inline-block;
}

.legend-label {
    color: var(--text-color, #e2e8f0);
}

.my-app-dark .legend-label {
    color: #e2e8f0;
}
</style>
